<div [ngClass]="isDialog ? 'card-content' : 'embedded-content'">
	<!-- Header nur anzeigen wenn gewünscht -->
	@if (showHeader) {
		<div [ngClass]="isDialog ? 'card-header' : 'embedded-header'">
			@if (isDialog) {
				<mat-icon class="mep-dialog-header-icon" svgIcon="bell_icon"></mat-icon>
			}
			@if (!isDialog) {
				<h3 [ngClass]="isDialog ? 'card-title' : 'embedded-title'">
					{{ _lang("notifications") }}
					@if (!archiveOpen && getUnreadNotificationCount() > 0) {
						<span class="notification-badge">
							{{ getUnreadNotificationCount() }}
						</span>
					}
				</h3>
			}
		</div>
	}

	<ng-template #notificationContent>
		<!-- Controls -->
		<div class="d-flex align-items-stretch gap-2" [class.flex-wrap]="isDialog" [ngClass]="{'mb-3': isDialog}">
			<mat-button-toggle-group
				[ngClass]="
					isDialog
						? 'switch-buttons mep-toggle-button-container h-100'
						: 'embedded-switch-buttons mep-toggle-button-container h-100'
				"
			>
				<mat-button-toggle checked class="mep-toggle-button" (click)="showActiveAssignments()" disableRipple>
					{{ _lang("activeNotification") }}
				</mat-button-toggle>
				<mat-button-toggle class="mep-toggle-button" (click)="showArchive()" disableRipple>
					{{ _lang("archive") }}
				</mat-button-toggle>
			</mat-button-toggle-group>
			<mat-form-field
				appearance="outline"
				[ngClass]="isDialog ? 'search-input h-100' : 'embedded-search-input h-100'"
			>
				<mat-label>{{ "mep.components.general.search" | translate }}</mat-label>
				<input matInput (keyup)="applyFilter($event)" />
			</mat-form-field>
		</div>
		<!-- Table -->
		<div
			[ngClass]="isDialog ? 'table-wrapper m row flex-grow-1 overflow-auto pt-2 pb-3' : 'embedded-table-container'"
		>
			<div class="col height-100">
				<mat-progress-bar [hidden]="!loading" mode="indeterminate"></mat-progress-bar>
				<div [ngClass]="isDialog ? 'table-container' : 'embedded-table'">
					<table matSort mat-table [dataSource]="dataSource" [ngClass]="isDialog ? '' : 'embedded-compact-table'">
						<!-- Checkbox Column -->
						<ng-container matColumnDef="checkBox" class="row-text">
							<th class="th-id" mat-header-cell *matHeaderCellDef>
								<mat-checkbox
									(change)="$event ? masterToggle() : null"
									[checked]="selection.hasValue() && isAllSelected()"
									[indeterminate]="selection.hasValue() && !isAllSelected()"
								></mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row" class="td-id">
								<mat-checkbox
									(change)="$event ? selection.toggle(row) : null"
									[checked]="selection.isSelected(row)"
								></mat-checkbox>
							</td>
						</ng-container>
						<!-- Sender -->
						<ng-container matColumnDef="sender">
							<th *matHeaderCellDef class="th-standard" mat-header-cell mat-sort-header>{{ _lang("sender") }}</th>
							<td *matCellDef="let element" mat-cell>{{ element.sender }}</td>
						</ng-container>
						<!-- Recipient -->
						<ng-container matColumnDef="recipient">
							<th *matHeaderCellDef class="th-standard" mat-header-cell mat-sort-header>{{ _lang("recipient") }}</th>
							<td *matCellDef="let element" mat-cell>{{ element.recipient }}</td>
						</ng-container>
						<!-- Date -->
						<ng-container matColumnDef="createdAt">
							<th *matHeaderCellDef class="th-standard" mat-header-cell mat-sort-header>{{ _lang("createdAt") }}</th>
							<td *matCellDef="let element" mat-cell class="small-column">{{ formatDate(element.createdAt) }}</td>
						</ng-container>
						<!-- Status -->
						<ng-container matColumnDef="assignmentStatus">
							<th *matHeaderCellDef class="th-standard" mat-header-cell mat-sort-header>
								{{ _lang("assignmentStatus") }}
							</th>
							<td mat-cell *matCellDef="let element" class="small-column">{{ element.assignmentStatus }}</td>
						</ng-container>
						<!-- Details -->
						<ng-container matColumnDef="employeeText">
							<th class="th-details" mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("details") }}</th>
							<td class="td-details" mat-cell *matCellDef="let element">
								<div [ngClass]="isDialog ? '' : 'embedded-compact-details'">
									<span>{{ element.employeeText }}</span>
									<a class="hoverLink" routerLink="/project-edit/{{ element.sharePointId }}">{{
										element.projectName
									}}</a>
									@if (isDialog) {
										<span>{{ element.capacityText }}</span>
									}
									@if (!isDialog) {
										<div class="capacity-info-small">
											{{ formatDate(element.assignmentEffectiveFrom) }}
											- {{ formatDate(element.assignmentEffectiveUntil) }} ({{ element.assignmentCapacity
											}}{{ _lang("capacity") }})
										</div>
									}
								</div>
							</td>
						</ng-container>
						<!-- Type -->
						<ng-container matColumnDef="type">
							<th class="th-type" mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("type") }}</th>
							<td class="td-type" mat-cell *matCellDef="let element">{{ element.type }}</td>
						</ng-container>
						<ng-container matColumnDef="statusRead">
							<th *matHeaderCellDef></th>
							<td *matCellDef="let element"></td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'bold-row': !row.read}"></tr>
					</table>
				</div>
			</div>
			<!-- Pagination nur wenn gewünscht -->
			@if (showPagination) {
				<app-paginator-smart
					[ngClass]="isDialog ? 'mat-paginator-sticky' : 'embedded-paginator'"
					[defaultPageSize]="10"
				>
				</app-paginator-smart>
			}
		</div>
	</ng-template>

	<!-- Content -->
	@if (gotUser && isDialog) {
		<div class="dialog-spacer" mat-dialog-content>
			<ng-container [ngTemplateOutlet]="notificationContent"></ng-container>
		</div>
	}

	@if (gotUser && !isDialog) {
		<div class="embedded-body" [style.overflow-y]="'auto'">
			<ng-container [ngTemplateOutlet]="notificationContent"></ng-container>
		</div>
	}

	<!-- No User Message -->
	@if (!gotUser && !loading && isDialog) {
		<div class="mep-dialog-content" mat-dialog-content>
			<span>{{ _lang("noUserFound") }}</span>
		</div>
	}

	@if (!gotUser && !loading && !isDialog) {
		<div class="embedded-no-user">
			<span>{{ _lang("noUserFound") }}</span>
		</div>
	}

	<!-- Actions - nur wenn gewünscht und in Dialog-Modus -->
	@if (showActions && isDialog) {
		<div class="mep-dialog-actions">
			<button class="mep-btn-dialog-secondary" (click)="closeDialog()">{{ _lang("close") }}</button>
			@if (gotUser) {
				<button
					class="mep-btn-dialog-primary"
					[disabled]="hasInformation() || archiveOpen"
					(click)="declineAssignment()"
				>
					{{ _lang("decline") }}
				</button>
			}
			@if (gotUser) {
				<button
					class="mep-btn-dialog-primary"
					[disabled]="hasInformation() || archiveOpen"
					(click)="acceptAssignment()"
				>
					{{ _lang("accept") }}
				</button>
			}
		</div>
	}

	<!-- Embedded Actions Nicht-Dialog-Modus -->
	@if (showActions && !isDialog && gotUser) {
		<div class="embedded-actions">
			<button mat-button color="warn" [disabled]="hasInformation() || archiveOpen" (click)="declineAssignment()">
				{{ _lang("decline") }}
			</button>
			<button
				class="embedded-actions-submit"
				mat-raised-button
				color="primary"
				[disabled]="hasInformation() || archiveOpen"
				(click)="acceptAssignment()"
			>
				{{ _lang("accept") }}
			</button>
		</div>
	}
</div>
